import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Function to extract first image from blogger HTML content 
// Blogger API doesn't always provide a featured image natively
export function extractFirstImage(htmlContent: string, width: number = 800, height: number = 450): string {
  const match = htmlContent.match(/<img[^>]+src=["']([^"']+)["']/i);
  let src = match ? match[1] : "https://images.unsplash.com/photo-1585829365295-ab7cd400c167?w=1200&q=80"; // Fallback image
  
  if (src.startsWith('//')) {
    src = 'https:' + src;
  }
  
  if (src.includes('blogger.googleusercontent.com/img/') || src.includes('bp.blogspot.com')) {
    src = src.replace(/\/[swh]\d+.*?\//i, `/w${width}-h${height}-p-k-no-nu/`);
    src = src.replace(/=s\d+-c/i, `=w${width}-h${height}-p-k-no-nu`);
  }
  return src;
}

export function optimizeBloggerImage(originalSrc: string): { src: string, srcSet: string, sizes: string } {
  let src = originalSrc;
  if (src.startsWith('//')) {
    src = 'https:' + src;
  }
  let srcSet = "";
  let sizes = "";

  if (src.includes('blogger.googleusercontent.com/img/') || src.includes('bp.blogspot.com')) {
    // Generate different sizes
    const sm = src.replace(/\/[swh]\d+.*?\//i, '/s600/').replace(/=s\d+-?[a-zA-Z]*/i, '=s600');
    const md = src.replace(/\/[swh]\d+.*?\//i, '/s800/').replace(/=s\d+-?[a-zA-Z]*/i, '=s800');
    const lg = src.replace(/\/[swh]\d+.*?\//i, '/s1200/').replace(/=s\d+-?[a-zA-Z]*/i, '=s1200');
    const xl = src.replace(/\/[swh]\d+.*?\//i, '/s1600/').replace(/=s\d+-?[a-zA-Z]*/i, '=s1600');

    // fallback src
    src = lg;
    
    // srcSet
    srcSet = `${sm} 600w, ${md} 800w, ${lg} 1200w, ${xl} 1600w`;
    // sizes
    sizes = "(max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1200px) 1200px, 1600px";
  }

  return { src, srcSet, sizes };
}

export function stripHtml(html: string): string {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export function formatBDDate(dateStr: string | Date, includeTime = true): string {
    const d = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
    const opts: Intl.DateTimeFormatOptions = {
        timeZone: 'Asia/Dhaka',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    if (includeTime) {
        opts.hour = '2-digit';
        opts.minute = '2-digit';
        opts.hour12 = true;
    }
    let formatted = new Intl.DateTimeFormat('bn-BD', opts).format(d);
    formatted = formatted.replace(' এ ', ' • ');
    return formatted;
}
